import {useEffect, useState} from 'react'

/**
 * "A LOCATION FIX HAS ARRIVED ON THIS DEVICE" — proof that location is allowed.
 *
 * ⚠️ WHY THIS EXISTS: iOS. Safari's Permissions API reports "prompt" for a site that is
 * allowed (and older iOS has no Permissions API), so `usePreciseLocation` — which waited
 * for "granted" — never ran on an iPhone and an Approximate grant was never caught. A fix
 * that actually arrived is the one answer every browser gives honestly, and reading it
 * from the screens that already ask (the tracking map, the welcome card's button) means
 * nothing new ever raises the native prompt.
 */
let working = false
const listeners = new Set()

export function markLocationWorking() {
    if (working) return
    working = true
    listeners.forEach((fn) => fn(true))
}

export function useLocationWorking() {
    const [value, setValue] = useState(working)
    useEffect(() => {
        setValue(working)
        listeners.add(setValue)
        return () => { listeners.delete(setValue) }
    }, [])
    return value
}
